import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import deviceDetector from './utils/deviceDetector'
import { useThemeStore } from './store/theme'
import { installAppUpdate } from './utils/appUpdate.mjs'
import { installAuthLifecycle } from './utils/authNavigation.mjs'
import { useAuthStore } from './store/auth'
import './assets/styles/monitoring-workspace.css'
import request, { bindAuthVersion } from './utils/request'
import { installWindowDiagnostics } from './utils/windowDiagnostics.mjs'

// 本地 OIDC 回调固定登记为 127.0.0.1，统一来源以保留浏览器会话绑定。
if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
  const canonical = new URL(window.location.href)
  canonical.hostname = '127.0.0.1'
  window.location.replace(canonical.href)
}
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
bindAuthVersion(() => {
  const auth = useAuthStore(pinia)
  return `${auth.authVersion}:${auth.identityVersion}`
}, () => useAuthStore(pinia).loggingOut, () => {
  const auth = useAuthStore(pinia)
  auth.clearAuth()
  auth.errorStatus = 401
  document.dispatchEvent(new Event('microquake:auth-expired'))
}, () => useAuthStore(pinia).isAuthenticated)
installAppUpdate(router)
app.use(router)
const stopAuthLifecycle = installAuthLifecycle(router, useAuthStore(pinia))
const stopWindowDiagnostics = installWindowDiagnostics(router, request)
if (module.hot) module.hot.dispose(stopWindowDiagnostics)
if (module.hot) module.hot.dispose(stopAuthLifecycle)
app.use(deviceDetector)
const themeStore = useThemeStore(pinia)
themeStore.apply()
app.mount('#app')
